import { render, staticRenderFns } from "./TransactionInfo.vue?vue&type=template&id=e5413138&"
import script from "./TransactionInfo.vue?vue&type=script&lang=js&"
export * from "./TransactionInfo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports